// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","mobile-threshold-width":"760px","container":"OrderTerms_container__OSalN","header":"OrderTerms_header__JGwrs","table":"OrderTerms_table__pXKbU"};